/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:38
 */
import { Post, Get, Patch, Put, Delete, Download, ax, Import } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Anomaly {
    /**
     *  异常列表
     */
    export var GetAnomalyList = (data): Promise<any> => {
        return Get(`/msls/Anomaly/GetAnomalyList?${qs.stringify(data)}`, '');
    };
    /**
     * 获取异常详情
     */
    export var AnomalyGetDetail = (id: any): Promise<any> => {
        return Get(`/msls/Anomaly/GetDetail/${id}`, {});
    };
    /**
     *  编辑异常AnomalyUpdate
     */
    export var AnomalyUpdate = (data: any): Promise<any> => {
        return Put(`/msls/Anomaly/Update`, data);
    };
    /**
     *  异常导出
     */
    export var AnomalyListExport = (data: any): Promise<any> => {
        return Download(`/msls/Anomaly/AnomalyListExport?${qs.stringify(data)}`, '');
    };
    /**
     * 获取客户/基地名称
     */
    export var GetDropDownList = (data):Promise<any> =>{
        return Get(`/msls/CustomerBase/GetDropDownList?${qs.stringify(data)}`,{});
    }
    /**
     * 获取车队
     */
    export var GetCarrierList =(data):Promise<any> =>{
        return Get(`/msls/Carrier/GetCarrierList?${qs.stringify(data)}`,{});
    }
    /**
     * 删除异常
     */
    export var AnomalyDelete = (id:any):Promise<any>=>{
        return Get(`/msls/Anomaly/${id}`,{})
    }
}
